import React, {Component} from 'react';
import Container from "@/components/Container";
import Iframe from '@/components/Iframe';

/**
 * 手机端-学校管理
 */
export default class School extends Component {
  render() {
    const IframeDom = Iframe({
      src: `https://t.xiaoyuanhao.com/v2-iframe/workbenchMenu/school`,
    });

    return (
      <Container breStates defaultPadding>
        <div style={{padding: '0 17px', marginTop: -15}}>
          <IframeDom />
        </div>
      </Container>
    );
  }
}
